import WrappedButton from '@/components/ui/WrappedButton';
import { globalModals, GLOBAL_MODALS } from '@/state/globalSettings';
import { userInfoState } from '@/state/userInfo';
import useTheme from '@/theme/useTheme';
import { KeyboardArrowRight } from '@mui/icons-material';
import { Typography, useMediaQuery } from '@mui/material';
import { Stack } from '@mui/system';
import { useAtom, useAtomValue } from 'jotai';
import { useTranslation } from 'next-i18next';
import Link from 'next/link';

export const DepositBtn = () => {
  const [_, setModals] = useAtom(globalModals);
  const [t] = useTranslation('promotion');
  const { userMetaData } = useAtomValue(userInfoState);

  const { theme } = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleBtnClick = () => {
    if (!userMetaData?.name) {
      setModals({
        [GLOBAL_MODALS.LOGIN]: true,
      });
      return;
    }
    setModals({
      [GLOBAL_MODALS.WALLET]: true,
    });
  };

  return (
    <Stack
      direction={'row'}
      alignItems={'center'}
      justifyContent={isMobile ? 'center' : 'flex-start'}
      sx={{
        position: 'relative',
        width: '100%',
      }}
    >
      <WrappedButton
        onClick={handleBtnClick}
        sx={{
          height: '38px',
          width: {
            xs: '100%',
            sm: '85px',
            md: '132px',
          },
          fontSize: '14px',
          whiteSpace: 'no-wrap',
          backgroundColor: theme.palette.primary.main,
        }}
      >
        {userMetaData?.name ? t('Deposit Now') : t('Register Now')}
      </WrappedButton>
    </Stack>
  );
};

export const Stage1Text = () => {
  return (
    <>
      <Typography
        variant="body1"
        className="bouns_amount"
        fontWeight={600}
        fontSize={'14px'}
        color="#0B0E11"
        sx={{
          marginBottom: '66%',
        }}
      >
        125% BONUS
      </Typography>
      <Typography
        variant="body1"
        fontWeight={600}
        fontSize={'14px'}
        color="#0B0E11"
      >
        First Deposit
      </Typography>
    </>
  );
};
export const Stage2Text = () => {
  return (
    <>
      <Typography
        variant="body1"
        fontWeight={600}
        fontSize={'14px'}
        color="#0B0E11"
        sx={{
          marginBottom: '66%',
        }}
      >
        150% BONUS
      </Typography>
      <Typography
        variant="body1"
        fontWeight={600}
        fontSize={'14px'}
        color="#0B0E11"
      >
        Second Deposit
      </Typography>
    </>
  );
};
export const Stage3Text = () => {
  return (
    <>
      <Typography
        variant="body1"
        fontWeight={600}
        fontSize={'14px'}
        color="#0B0E11"
        sx={{
          marginBottom: '66%',
        }}
      >
        175% BONUS
      </Typography>
      <Typography
        variant="body1"
        fontWeight={600}
        fontSize={'14px'}
        color="#0B0E11"
      >
        Third Deposit
      </Typography>
    </>
  );
};
export const Stage4Text = () => {
  return (
    <>
      <Typography
        variant="body1"
        fontWeight={600}
        fontSize={'14px'}
        color="#0B0E11"
        sx={{
          marginBottom: '66%',
        }}
      >
        200% BONUS
      </Typography>
      <Typography
        variant="body1"
        fontWeight={600}
        fontSize={'14px'}
        color="#0B0E11"
      >
        Fourth Deposit
      </Typography>
    </>
  );
};

export const DetailsComp = ({ label }: { label: string }) => {
  return (
    <Link
      href={'/benefits/deposit'}
      style={{
        width: '100%',
        textDecoration: 'none',
      }}
    >
      <Stack
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: {
            xs: 'center',
            md: 'flex-start',
            width: '100%',
            height: '100%',
          },
        }}
      >
        <Typography
          variant="body2"
          sx={{
            cursor: 'pointer',
          }}
          fontWeight={500}
          fontSize={'12px'}
          color={'#F0B90B'}
        >
          {label}
        </Typography>
        <KeyboardArrowRight
          sx={{
            width: '20px',
            color: '#F0B90B',
          }}
        />
      </Stack>
    </Link>
  );
};
